module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAUVBMVEUAAAD///////////////////////////////////////////////8zMzNGRkbf39/29vZlZWU2Nja5ubmurq5VVVXk5OS7u7uhoaGLi4uBgYE1OAZOAAAADHRSTlMAPvnr59jHwolUIQFfym6cAAAArUlEQVQoz32T6w6DIAyFC4KgVHSb7vb+D7rFAyRg6PeryRdu7YEyQXlntDbOq0ANk+WCnSo1j1wxzlRQAzcMqjjNF3SyM9Y1DNgZ510Yz3tyh4ko2J60gRR3UeT70pNDsccXg/X4MnBkUHyW+wMuLgcDQxrFdvtbuLgy0JDFwhVpUMC+4RIGF8p2gUs4PCVbuIyvmrDtz6oJYvukxksjE4ctxUQOmBxNOdTid/gBOvodKB+tsi8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/publicClass/kecheng_icon_drop-down.png
// module id = rfgn
// module chunks = 23